import { render, staticRenderFns } from "./menuRestrito.vue?vue&type=template&id=7003fa70"
import script from "./menuRestrito.vue?vue&type=script&lang=js"
export * from "./menuRestrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports